var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cost_Icon",
    "data-name": "Cost Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M20.936,10.466A10.476,10.476,0,0,0,10.47,0h-.4A8.935,8.935,0,0,0,9,.1,10.46,10.46,0,1,0,20.808,12.055c.054-.353.086-.712.107-1.07C20.92,10.808,20.936,10.642,20.936,10.466Zm-10.466,9.4A9.39,9.39,0,0,1,9,1.2a8.946,8.946,0,0,1,1.07-.107h.4a9.406,9.406,0,0,1,9.4,9.374c0,.177,0,.348,0,.535a8.973,8.973,0,0,1-.123,1.07A9.4,9.4,0,0,1,10.47,19.861Z",
    transform: "translate(1.21 1.221)",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6007_-_Outline",
    "data-name": "Path 6007 - Outline",
    d: "M9.987-.3h.4A10.7,10.7,0,0,1,21.078,10.386c0,.112-.006.218-.012.321,0,.067-.008.136-.01.2v.006c-.025.411-.06.767-.109,1.09A10.681,10.681,0,0,1,10.4,21.054c-.2,0-.4-.006-.6-.017A10.681,10.681,0,0,1,8.889-.2,9.179,9.179,0,0,1,9.983-.3ZM20.615,10.9c0-.073.006-.144.01-.213.006-.1.011-.2.011-.3A10.256,10.256,0,0,0,10.391.142h-.4a8.745,8.745,0,0,0-1.04.094A10.239,10.239,0,0,0,9.824,20.6c.191.011.384.016.575.016A10.24,10.24,0,0,0,20.51,11.942C20.557,11.634,20.591,11.291,20.615,10.9ZM9.986.792h.406a9.627,9.627,0,0,1,9.616,9.594v.548a9.23,9.23,0,0,1-.126,1.1A9.622,9.622,0,0,1,10.4,20h-.011A9.611,9.611,0,0,1,8.885.9a9.2,9.2,0,0,1,1.1-.11Zm9.58,10.124v-.529a9.185,9.185,0,0,0-9.175-9.153h-.4a8.756,8.756,0,0,0-1.039.1,9.169,9.169,0,0,0,1.437,18.224h.01a9.18,9.18,0,0,0,9.044-7.607A8.786,8.786,0,0,0,19.566,10.915Z",
    transform: "translate(1.289 1.3)",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M.88-4.65v-.888l1.372-.193q-.158-.58-.277-1.139a5.178,5.178,0,0,1-.119-1.077A3.6,3.6,0,0,1,2.137-9.39,3.253,3.253,0,0,1,2.911-10.5,3.326,3.326,0,0,1,4.1-11.2a4.656,4.656,0,0,1,1.539-.242,4.829,4.829,0,0,1,2.436.638A4.737,4.737,0,0,1,9.814-9.135l-.879.721L8.02-9.082a6.019,6.019,0,0,0-1.156-.655A3.227,3.227,0,0,0,5.6-9.979a2.38,2.38,0,0,0-1.6.51A1.918,1.918,0,0,0,3.4-7.93a4.834,4.834,0,0,0,.119,1.016q.119.55.295,1.112H7.545V-4.65H4.16A5.809,5.809,0,0,1,4.485-3a2.1,2.1,0,0,1-.295,1.082,8.6,8.6,0,0,1-.945,1.24H9.885V.679H1.513V-.183a.932.932,0,0,1,.026-.259.849.849,0,0,1,.176-.251l.519-.642a4.012,4.012,0,0,0,.576-.884,1.864,1.864,0,0,0,.145-.725,3.168,3.168,0,0,0-.11-.747q-.11-.44-.268-.959Z",
    transform: "translate(6.301 16.338)",
    fill: "#525252"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1964",
    "data-name": "Rectangle 1964",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostIcon);
export default __webpack_public_path__ + "static/media/cost_icon.e0534b936be022785f046fa8bfb5496c.svg";
export { ForwardRef as ReactComponent };